import { API_BASE } from '../config';

const CONNECTION_ERROR = 'Error de conexión. Intenta de nuevo.';

// Every call resolves to {ok, status, data}; a network failure is status 0.
async function request(method, path, body, token) {
  const headers = { Authorization: `Token ${token}` };
  const options = { method, headers };
  if (body !== undefined) {
    headers['Content-Type'] = 'application/json';
    options.body = JSON.stringify(body);
  }
  try {
    const response = await fetch(`${API_BASE}/production/v2/${path}`, options);
    let data = null;
    try {
      data = await response.json();
    } catch (err) {
      data = null;
    }
    return { ok: response.ok, status: response.status, data };
  } catch (err) {
    return { ok: false, status: 0, data: { error: CONNECTION_ERROR } };
  }
}

// Text to show the user for a failed response.
export function errorMessage(res) {
  const data = res && res.data;
  const status = res ? res.status : 0;
  if (data && data.error) return data.error;
  // DRF's 401 detail is in English and means the token is no longer valid.
  if (status === 401) return 'Tu sesión expiró. Vuelve a iniciar sesión.';
  if (data && data.detail) return data.detail;
  if (status === 0) return CONNECTION_ERROR;
  if (status === 403) return 'No tienes permiso para esta acción.';
  if (status === 404) return 'No se encontró.';
  return `Error del servidor (${status}). Intenta de nuevo.`;
}

export const produccionApi = {
  get: (path, token) => request('GET', path, undefined, token),
  send: (method, path, body, token) => request(method, path, body, token),
};

export default produccionApi;
